import { Controller } from "@hotwired/stimulus"

// MC-1308: swaps the credential config field's guidance when the provider-kind
// select changes. On change it points the guidance Turbo Frame at the `new`
// endpoint for the chosen kind; Turbo fetches and replaces just that frame, so
// the kind's example config shape (and, for the subscription kind, its
// constraint note) appears without a full navigation while the rest of the
// form is left untouched. Mirrors inbound_action_select_controller. Progressive:
// with no JS the select still submits and the server renders the matching
// guidance on the next request.
export default class extends Controller {
  static values = { url: String, frame: String }

  reload() {
    const frame = document.getElementById(this.frameValue)
    if (!frame) return

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("provider_kind", this.element.value)
    frame.setAttribute("src", url.pathname + url.search)
  }
}
